// initial filter value for any invoice screen
export const INITIAL_INVOICE_SELECTED_CLIENT_N_FILTER = { filter: "ALL_OPEN" };
